import { createUseStyles } from 'react-jss'

import { zIndex2 } from '../../../../../../styles/const/common'

const useStyles = createUseStyles({
  adStoriesCardButton: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: zIndex2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 5,
    background: 'linear-gradient(0deg, rgba(85, 85, 85, 0.28) 0%, rgba(196, 196, 196, 0) 100%)'
  },
  adStoriesCardIcon: {
    transform: 'rotate(180deg)',
    marginBottom: 2,

    '& path': {
      fill: 'white'
    }
  },
  storyActionButton: {
    borderRadius: 20,
    borderColor: '#fff',
    fontSize: 6,
    backgroundColor: 'white',
    paddingBottom: 1
  }
})

export default useStyles
